/* =========================================================
   PRÆSIDENT GULVE - MASTER JAVASCRIPT
   Formål:
   Samlet JavaScript-fil til Shopify.
   Reelle dubletter er fjernet.
   Funktionalitet er bevaret.
   ========================================================= */

(function () {
  /* =========================================================
     1. RELATED PRODUCTS SLIDER
     Bruges til alle .custom-related-products karuseller.
     Gør pilene aktive og scroller produktkort vandret.
     ========================================================= */
  function initRelatedSlider(section) {
    if (!section || section.dataset.ready === "true") return;
    section.dataset.ready = "true";

    var track = section.querySelector(".custom-related-products__track");
    var prevBtn = section.querySelector(".custom-related-products__arrow--prev");
    var nextBtn = section.querySelector(".custom-related-products__arrow--next");

    if (!track || !prevBtn || !nextBtn) return;

    function getStep() {
      var firstCard = track.querySelector(".custom-related-products__card");
      if (!firstCard) return 320;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 5;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 5;
    }

    prevBtn.addEventListener("click", function () {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);

    updateButtons();
  }

  function initAllRelatedSliders(root) {
    (root || document).querySelectorAll(".custom-related-products").forEach(initRelatedSlider);
  }


  /* =========================================================
     2. "LÆS MERE" PRODUKTBESKRIVELSE
     Bruges på produktkort/produktsektion.
     Scroller ned til Shopify produktbeskrivelsen.
     ========================================================= */
  window.scrollToProductDescription = function () {
  const target = document.querySelector(".pg-product-tabs-v4");

  if (target) {
    const offset = 100; // space below sticky header
    const y = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }
};


  /* =========================================================
     3. GPO QUANTITY MOVE
     Flytter quantity-feltet efter popup-triggeren.
     Bruges sammen med produkt-configuratorens knapper.
     ========================================================= */
  function moveGpoQuantity() {
    setTimeout(function () {
      var container = document.querySelector('[data-element-id="buttons-1"]');
      if (!container) return;

      var qty = container.querySelector(".gpo-quantity");
      var btn = container.querySelector(".gpo-popup-trigger");

      if (qty && btn) {
        btn.after(qty);
      }
    }, 1000);
  }


  /* =========================================================
     4. BUY NOW FORM
     Bruges til custom "Buy Now" form.
     Tilføjer produktet til kurv via AJAX og sender direkte til checkout.
     ========================================================= */
  function initBuyNowForm() {
    var form = document.getElementById("buy-now-form");
    if (!form || form.dataset.ready === "true") return;

    form.dataset.ready = "true";

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const button = form.querySelector("button");

      button.disabled = true;
      button.innerText = "Processing...";

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Add to cart failed");
          }
          return response.json();
        })
        .then(() => {
          window.location.href = "/checkout";
        })
        .catch(error => {
          console.error(error);
          button.disabled = false;
          button.innerText = "Buy Now";
          alert("Something went wrong. Please try again.");
        });
    });
  }


  /* =========================================================
     5. GPO POPUP / DRAWER SYSTEM
     Omdanner GPO produkt-configuratorens standardvalg til en flot popup/drawer.
     Bruges til:
     - Swatches
     - Dropdowns
     - Checkbox/radio valg
     - Parketlim quantity
     - Hjælp til montering
     ========================================================= */
  function initGpoPopupSystem() {
    if (window.pgGpoPopupSystemReady) return;
    window.pgGpoPopupSystemReady = true;

    const popupState = {
      currentField: null,
      tempValues: [],
      type: null,
      movedField: null,
      movedFieldPlaceholder: null,
      movedFieldOriginalParent: null,
      quantityProxyCleanup: null
    };

    let overlay, drawer, titleEl, subtitleEl, bodyEl, saveBtn, closeBtn, footerEl;

    function createSharedPopup() {
      if (document.querySelector(".gpo-popup-overlay")) {
        overlay = document.querySelector(".gpo-popup-overlay");
        drawer = document.querySelector(".gpo-popup-drawer");
        titleEl = drawer.querySelector(".gpo-popup-title");
        subtitleEl = drawer.querySelector(".gpo-popup-subtitle");
        bodyEl = drawer.querySelector(".gpo-popup-body");
        saveBtn = drawer.querySelector(".gpo-popup-save");
        closeBtn = drawer.querySelector(".gpo-popup-close");
        footerEl = drawer.querySelector(".gpo-popup-footer");
        return;
      }

      overlay = document.createElement("div");
      overlay.className = "gpo-popup-overlay";

      drawer = document.createElement("div");
      drawer.className = "gpo-popup-drawer";
      drawer.innerHTML = `
        <div class="gpo-popup-header">
          <div class="gpo-popup-header-left">
            <h3 class="gpo-popup-title"></h3>
            <div class="gpo-popup-subtitle">Vælg den løsning der passer bedst til dit gulv.</div>
          </div>
          <button type="button" class="gpo-popup-close" aria-label="Luk">&times;</button>
        </div>
        <div class="gpo-popup-body"></div>
        <div class="gpo-popup-footer">
          <button type="button" class="gpo-popup-save">Gem valg</button>
        </div>
      `;

      document.body.appendChild(overlay);
      document.body.appendChild(drawer);

      titleEl = drawer.querySelector(".gpo-popup-title");
      subtitleEl = drawer.querySelector(".gpo-popup-subtitle");
      bodyEl = drawer.querySelector(".gpo-popup-body");
      saveBtn = drawer.querySelector(".gpo-popup-save");
      closeBtn = drawer.querySelector(".gpo-popup-close");
      footerEl = drawer.querySelector(".gpo-popup-footer");

      overlay.addEventListener("click", closePopup);
      closeBtn.addEventListener("click", closePopup);
      saveBtn.addEventListener("click", applyPopupSelection);

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closePopup();
      });
    }

    function lockScroll() {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function unlockScroll() {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    function normalizeText(text) {
      return String(text || "")
        .toLowerCase()
        .replace(/æ/g, "ae")
        .replace(/ø/g, "oe")
        .replace(/å/g, "aa")
        .replace(/\s+/g, " ")
        .trim();
    }

    function escapeHtml(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function getFieldLabel(field) {
      const label = field.querySelector(".label-content");
      return label ? label.textContent.trim() : "Vælg mulighed";
    }

    function isParketlimField(field) {
      return normalizeText(getFieldLabel(field)).includes("parketlim");
    }

    function isMontageHelpField(field) {
      const label = normalizeText(getFieldLabel(field));
      return label.includes("hjaelp til monteringen") || label.includes("hjaelp til montering");
    }

    function isDarkButtonField(field) {
      const label = normalizeText(getFieldLabel(field));
      return label.includes("behandling") || label.includes("kant") || label.includes("andet");
    }

    function shouldConvertField(field) {
      if (!field || field.dataset.popupReady === "true") return false;
      if (field.closest(".gpo-popup-drawer")) return false;
      if (!field.querySelector(".label-content")) return false;

      const hasPopupOptions =
        field.querySelector(".gpo-swatches input") ||
        field.querySelector(".gpo-dropdown input") ||
        field.querySelector(".gpo-choicelist input");

      return !!hasPopupOptions;
    }

    function getFieldType(field) {
      if (field.querySelector(".gpo-dropdown input")) return "dropdown";
      if (field.querySelector('.gpo-choicelist input[type="checkbox"]')) return "checkbox";
      if (field.querySelector('.gpo-choicelist input[type="radio"]')) return "radio";
      if (field.querySelector('.gpo-swatches input[type="checkbox"]')) return "checkbox";
      if (field.querySelector('.gpo-swatches input[type="radio"]')) {
        return field.querySelector(".swatch-image") ? "image" : "radio";
      }
      return "unknown";
    }

    function getCurrentSelectedValues(field) {
      return Array.from(field.querySelectorAll("input:checked")).map(function (input) {
        return input.id;
      });
    }

    function getOptionTitle(input) {
      const item = input.closest(".gpo-ov-item") || input.parentElement;
      const tooltipWord = item ? item.querySelector(".gpo-tooltip__title .break-word") : null;
      const dropdownValue = item ? item.querySelector(".dropdown-item__value") : null;
      const choiceValue = item ? item.querySelector(".choicelist-item__value") : null;

      let value = "";
      if (tooltipWord) value = tooltipWord.textContent.trim();
      else if (dropdownValue) value = dropdownValue.textContent.replace(/\s+/g, " ").trim();
      else if (choiceValue) value = choiceValue.textContent.trim();
      else value = (input.getAttribute("original-value") || input.value || "").trim();

      value = value.replace(/\(\+\s*[\d.,\s]+(?:kr|dkk)\)/ig, "").trim();
      return value;
    }

    function normalizeAddonText(text) {
      const raw = String(text || "").replace(/\s+/g, " ").trim();
      if (!raw) return "";

      const clean = normalizeText(raw);
      if (
        clean === "0" ||
        clean === "0 kr" ||
        clean === "+0 kr" ||
        clean === "0,00 kr" ||
        clean === "+0,00 kr" ||
        clean.includes("gratis")
      ) {
        return "Gratis";
      }

      return raw;
    }

    function getOptionAddon(input) {
      const item = input.closest(".gpo-ov-item") || input.parentElement;
      const addon = item ? item.querySelector(".addOn") : null;
      return addon ? normalizeAddonText(addon.textContent) : "";
    }

    function getOptionImage(input) {
      const item = input.closest(".gpo-ov-item") || input.parentElement;
      const img = item ? item.querySelector(".swatch-image") : null;
      return img ? img.src : "";
    }
        function getOptionQuantityInput(input) {
      const item = input.closest(".gpo-ov-item");
      if (!item) return null;

      return item.querySelector('.gpo-quantity input[type="number"], input[type="number"]');
    }

    function fieldHasPerOptionQuantity(field) {
      return Array.from(field.querySelectorAll(".gpo-ov-item")).some(function (item) {
        return item.querySelector('.gpo-quantity input[type="number"], input[type="number"]');
      });
    }

    function triggerQuantityEvents(input) {
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("blur", { bubbles: true }));
    }

    function createPopupQuantityControl(originalInput) {
      const wrapper = document.createElement("div");
      wrapper.className = "gpo-popup-option-qty";

      const minus = document.createElement("button");
      minus.type = "button";
      minus.className = "gpo-popup-option-qty-btn";
      minus.textContent = "−";

      const input = document.createElement("input");
      input.type = "number";
      input.className = "gpo-popup-option-qty-input";
      input.value = originalInput.value || "1";
      input.min = originalInput.min || "1";
      input.step = originalInput.step || "1";

      if (originalInput.max) {
        input.max = originalInput.max;
      }

      const plus = document.createElement("button");
      plus.type = "button";
      plus.className = "gpo-popup-option-qty-btn";
      plus.textContent = "+";

      function syncToOriginal() {
        originalInput.value = input.value;
        triggerQuantityEvents(originalInput);
      }

      function changeValue(direction) {
        const step = parseFloat(input.step || "1");
        const min = parseFloat(input.min || "1");
        const max = input.max ? parseFloat(input.max) : null;
        let current = parseFloat(input.value || min);

        current = current + direction * step;

        if (current < min) current = min;
        if (max !== null && current > max) current = max;

        input.value = current;
        syncToOriginal();
      }

      minus.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        changeValue(-1);
      });

      plus.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        changeValue(1);
      });

      input.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      input.addEventListener("input", syncToOriginal);
      input.addEventListener("change", syncToOriginal);

      wrapper.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      wrapper.appendChild(minus);
      wrapper.appendChild(input);
      wrapper.appendChild(plus);

      return wrapper;
    }

    function getFieldOptions(field) {
      const type = getFieldType(field);
      let inputs = [];

      if (type === "dropdown") {
        inputs = Array.from(field.querySelectorAll(".gpo-dropdown input"));
      } else if (type === "checkbox") {
        inputs = Array.from(field.querySelectorAll(".gpo-choicelist input, .gpo-swatches input"));
      } else {
        inputs = Array.from(field.querySelectorAll(".gpo-swatches input, .gpo-choicelist input"));
      }

      const seen = new Set();

      return inputs
        .filter(function (input) {
          if (!input || !input.id || seen.has(input.id)) return false;
          seen.add(input.id);
          return true;
        })
        .map(function (input) {
          return {
            id: input.id,
            title: getOptionTitle(input),
            addon: getOptionAddon(input),
            image: getOptionImage(input),
            input: input
          };
        });
    }

    function getSelectedOption(field) {
      const options = getFieldOptions(field);
      const selectedId = popupState.tempValues[0];
      return options.find(function (option) {
        return option.id === selectedId;
      }) || null;
    }

    function shouldShowQuantity(field) {
      const selectedOption = getSelectedOption(field);
      if (!selectedOption) return false;

      const quantityField = findQuantityField(field);
      if (!quantityField) return false;

      return true;
    }

    function findQuantityField(field) {
      if (!field) return null;

      const directInput = field.querySelector(".gpo-dropdown input[data-field-name], .gpo-swatches input[data-field-name], .gpo-choicelist input[data-field-name]");
      const parentFieldName = directInput ? directInput.getAttribute("data-field-name") : "";

      if (parentFieldName) {
        const quantityInput = document.querySelector(
          '.gpo-quantity input[data-parent-field-name="' + CSS.escape(parentFieldName) + '"]'
        );
        if (quantityInput) return quantityInput.closest(".gpo-quantity");
      }

      let next = field.nextElementSibling;
      while (next) {
        if (next.classList && next.classList.contains("gpo-element")) break;
        const qty = next.querySelector ? next.querySelector(".gpo-quantity") : null;
        if (qty) return qty;
        next = next.nextElementSibling;
      }

      return null;
    }

    function restoreMovedField() {
      if (typeof popupState.quantityProxyCleanup === "function") {
        popupState.quantityProxyCleanup();
      }
      popupState.quantityProxyCleanup = null;
      popupState.movedField = null;
      popupState.movedFieldPlaceholder = null;
      popupState.movedFieldOriginalParent = null;
    }

    function moveQuantityFieldIntoPopup(field) {
      restoreMovedField();

      if (!shouldShowQuantity(field)) return;

      const quantityField = findQuantityField(field);
      if (!quantityField) return;

      const originalInput = quantityField.querySelector("input");
      if (!originalInput) return;

      const existingLabel = quantityField.querySelector(".gpo-quantity__label");
      const labelText = existingLabel ? existingLabel.textContent.trim() : "Antal";

      const wrapper = document.createElement("div");
      wrapper.className = "gpo-popup-extra-field";

      wrapper.innerHTML = `
        <div class="gpo-popup-extra-title">${escapeHtml(labelText)}</div>
        <div class="gpo-quantity">
          <input
            type="number"
            min="${escapeHtml(originalInput.min || "1")}"
            max="${escapeHtml(originalInput.max || "")}"
            step="${escapeHtml(originalInput.step || "1")}"
            value="${escapeHtml(originalInput.value || "1")}"
            class="gpo-quantity__input gpo-popup-quantity-proxy"
          >
        </div>
      `;

      bodyEl.appendChild(wrapper);

      const proxyInput = wrapper.querySelector(".gpo-popup-quantity-proxy");

      const syncToOriginal = function () {
        originalInput.value = proxyInput.value;
        originalInput.dispatchEvent(new Event("input", { bubbles: true }));
        originalInput.dispatchEvent(new Event("change", { bubbles: true }));
        originalInput.dispatchEvent(new Event("blur", { bubbles: true }));
      };

      const syncFromOriginal = function () {
        proxyInput.value = originalInput.value || proxyInput.value;
      };

      proxyInput.addEventListener("input", syncToOriginal);
      proxyInput.addEventListener("change", syncToOriginal);
      originalInput.addEventListener("input", syncFromOriginal);
      originalInput.addEventListener("change", syncFromOriginal);

      popupState.quantityProxyCleanup = function () {
        proxyInput.removeEventListener("input", syncToOriginal);
        proxyInput.removeEventListener("change", syncToOriginal);
        originalInput.removeEventListener("input", syncFromOriginal);
        originalInput.removeEventListener("change", syncFromOriginal);
      };
    }

    function renderPopupHelp(field) {
      if (!isMontageHelpField(field)) return;

      const help = document.createElement("div");
      help.className = "gpo-popup-help";
      help.innerHTML = `
        <em>* Hvis I trykker ja:</em> I vil blive ringet op af vores dygtige montagefirma, som gratis kan komme ud og give jer et tilbud på lægningen af jeres gulv i forbindelse med køb af gulvet hos Præsidentgulve.
      `;
      bodyEl.appendChild(help);
    }

    function renderPopupOptions(field) {
      bodyEl.innerHTML = "";
      restoreMovedField();

      renderPopupHelp(field);

      const type = getFieldType(field);
      const options = getFieldOptions(field);

      const grid = document.createElement("div");
      grid.className = "gpo-popup-grid";

      const hasImages = options.some(function (option) {
        return !!option.image;
      });

      if (!hasImages) {
        grid.classList.add("text-list");
      }

      const useDarkButtons = isDarkButtonField(field);

      options.forEach(function (option) {
        const active = popupState.tempValues.includes(option.id);
        const hasImage = !!option.image;

        const card = document.createElement("div");
        card.className = "gpo-popup-option" + (active ? " active" : "") + (!hasImage ? " text-only" : "");
        card.setAttribute("data-option-id", option.id);

        const addonHtml = option.addon ? `<div class="gpo-popup-option-addon">${escapeHtml(option.addon)}</div>` : "";
        const buttonStyle = useDarkButtons ? ' style="background:#111;color:#fff;border-color:#111;"' : "";

        if (hasImage) {
          card.innerHTML = `
            <div class="gpo-popup-option-image">
              <img src="${option.image}" alt="${escapeHtml(option.title)}">
            </div>
            <div class="gpo-popup-option-content">
              <div class="gpo-popup-option-title">${escapeHtml(option.title)}</div>
              ${addonHtml}
              <div class="gpo-popup-option-select"${buttonStyle}>Vælg</div>
            </div>
          `;
        } else {
          card.innerHTML = `
            <div class="gpo-popup-option-content">
              <div class="gpo-popup-option-title">${escapeHtml(option.title)}</div>
              ${addonHtml}
              <div class="gpo-popup-option-select"${buttonStyle}>Vælg</div>
            </div>
          `;
        }
        const optionQuantityInput = getOptionQuantityInput(option.input);

        if (optionQuantityInput) {
          const content = card.querySelector(".gpo-popup-option-content");

          if (content) {
            content.appendChild(createPopupQuantityControl(optionQuantityInput));
          }
        }

        card.addEventListener("click", function (event) {
        if (event.target.closest(".gpo-popup-option-qty")) {
          return;
        }

        if (type === "checkbox") {
          if (popupState.tempValues.includes(option.id)) {
            popupState.tempValues = popupState.tempValues.filter(function (id) {
              return id !== option.id;
            });
          } else {
            popupState.tempValues.push(option.id);
          }

          renderPopupOptions(field);
          return;
        }

  popupState.tempValues = [option.id];

  renderPopupOptions(field);
});

        grid.appendChild(card);
      });

      bodyEl.appendChild(grid);

      if (!fieldHasPerOptionQuantity(field)) {
      moveQuantityFieldIntoPopup(field);
}
    }

    function clickOriginalOption(field, inputId) {
      const input = field.querySelector("#" + CSS.escape(inputId));
      if (!input) return false;

      const label = field.querySelector('label[for="' + CSS.escape(inputId) + '"]');
      if (label) {
        label.click();
        return true;
      }

      input.click();
      return true;
    }

    function getSelectedText(field) {
      const checkedInputs = Array.from(field.querySelectorAll("input:checked"));
      if (!checkedInputs.length) return "Tryk for at vælge";

      return checkedInputs.map(function (input) {
        const title = getOptionTitle(input);
        const addon = getOptionAddon(input);
        return addon ? title + " " + addon : title;
      }).join(", ");
    }

    function updateTriggerValue(field) {
      const triggerValue = field.querySelector(".gpo-popup-trigger-value");
      const selectedValueEl = field.querySelector(".gpo-selected-values");
      const value = getSelectedText(field);

      if (triggerValue) triggerValue.textContent = value;
      if (selectedValueEl) selectedValueEl.textContent = value;
    }

    function applyPopupSelection() {
      const field = popupState.currentField;
      if (!field) return;

      const type = getFieldType(field);
      const inputs = Array.from(field.querySelectorAll('input[type="radio"], input[type="checkbox"]'));

      if (type === "checkbox") {
        inputs.forEach(function (input) {
          const shouldBeChecked = popupState.tempValues.includes(input.id);
          if (input.checked !== shouldBeChecked) {
            clickOriginalOption(field, input.id);
          }
        });
      } else {
        const selectedId = popupState.tempValues[0];
        if (selectedId) {
          clickOriginalOption(field, selectedId);
        }
      }

      setTimeout(function () {
        updateTriggerValue(field);
        closePopup();
      }, 80);
    }

  function openPopup(field) {
    popupState.currentField = field;
    popupState.type = getFieldType(field);
    popupState.tempValues = getCurrentSelectedValues(field);

    titleEl.textContent = getFieldLabel(field) || "Vælg mulighed";

    subtitleEl.textContent = "Vælg den løsning der passer bedst til dit gulv, og tryk derefter på Bekræft valg.";
    footerEl.classList.remove("hidden");

    if (saveBtn) {
      saveBtn.textContent = "Bekræft valg";
    }

    renderPopupOptions(field);

    overlay.classList.add("active");
    drawer.classList.add("active");
    lockScroll();
  }

    function closePopup() {
      if (!overlay || !drawer) return;
      overlay.classList.remove("active");
      drawer.classList.remove("active");
      restoreMovedField();
      unlockScroll();
    }

    function initPopupField(field) {
      if (!shouldConvertField(field)) return;

      field.dataset.popupReady = "true";

      const labelEl = field.querySelector(".gpo-label");
      const selectedValueEl = field.querySelector(".gpo-selected-values");
      const labelText = getFieldLabel(field);

      const existingHelp = field.querySelector(".gpo-inline-help");
      if (existingHelp) {
        existingHelp.style.display = "none";
      }

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = "gpo-popup-trigger";
      trigger.innerHTML = `
        <span class="gpo-popup-trigger-left">
          <span class="gpo-popup-trigger-label">${escapeHtml(labelText)}</span>
          <span class="gpo-popup-trigger-value">${escapeHtml(getSelectedText(field))}</span>
        </span>
        <span class="gpo-popup-trigger-icon">›</span>
      `;

      const originalBlocks = field.querySelectorAll(".gpo-ov-wrapper, .gpo-dropdown, .gpo-select");
      originalBlocks.forEach(function (el) {
        el.classList.add("gpo-popup-hidden-original");
      });

      if (labelEl) labelEl.style.display = "none";
      if (selectedValueEl) selectedValueEl.style.display = "none";

      field.appendChild(trigger);

      trigger.addEventListener("click", function () {
        openPopup(field);
      });

      field.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
        input.addEventListener("change", function () {
          updateTriggerValue(field);
        });
      });

      updateTriggerValue(field);
    }

    function initAllPopupFields() {
      createSharedPopup();
      document.querySelectorAll(".gpo-element").forEach(initPopupField);
    }

    initAllPopupFields();

    const observer = new MutationObserver(function () {
      initAllPopupFields();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  /* =========================================================
     6. GLOBAL INITIALIZATION
     Kører alt når siden loader.
     Shopify section reload understøttes også.
     ========================================================= */
  document.addEventListener("DOMContentLoaded", function () {
    initAllRelatedSliders(document);
    moveGpoQuantity();
    initBuyNowForm();
    initGpoPopupSystem();
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllRelatedSliders(event.target);
    moveGpoQuantity();
    initBuyNowForm();
  });
})();


/*
  LUX SLIDER JAVASCRIPT
  Funktionalitet til forsideslider/banner:
  næste/forrige pile, aktiv slide, progress bar og automatisk skift hvert 5. sekund.
*/

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".lux-slider");

  if (!slider) return;

  const slides = slider.querySelectorAll(".lux-slide");
  const nextBtn = slider.querySelector(".lux-next");
  const prevBtn = slider.querySelector(".lux-prev");

  if (!slides.length || !nextBtn || !prevBtn) return;

  let current = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });

    slider.classList.toggle("slide-2", index === 1);
  }

  nextBtn.addEventListener("click", function () {
    current = (current + 1) % slides.length;
    showSlide(current);
  });

  prevBtn.addEventListener("click", function () {
    current = (current - 1 + slides.length) % slides.length;
    showSlide(current);
  });

  setInterval(function () {
    current = (current + 1) % slides.length;
    showSlide(current);
  }, 5000);

  showSlide(current);
});
/* =========================================================
   GPO CONFIGURATOR — FINAL 4-COLUMN SWATCH LAYOUT
   ========================================================= */
(function () {
  var css = `
    .gpo-popup-grid {
      display: grid !important;
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
      gap: 12px !important;
    }

    .gpo-popup-grid.text-list {
      grid-template-columns: 1fr !important;
    }

    .gpo-popup-option {
      position: relative !important;
      display: flex !important;
      flex-direction: column !important;
      border: 0.5px solid #e6e6e6 !important;
      border-radius: 16px !important;
      background: #fff !important;
      overflow: hidden !important;
      box-shadow: none !important;
      cursor: pointer !important;
      transition: transform .18s ease, border-color .18s ease, box-shadow .18s ease !important;
    }

    .gpo-popup-option:hover {
      transform: translateY(-2px) !important;
      border-color: #cdcdcd !important;
      box-shadow: 0 12px 26px rgba(0,0,0,0.08) !important;
    }

    .gpo-popup-option-image {
      width: 100% !important;
      aspect-ratio: 1 / 1 !important;
      flex-shrink: 0 !important;
      overflow: hidden !important;
      background: #f4f3f0 !important;
    }

    .gpo-popup-option-image img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      display: block !important;
    }

    .gpo-popup-option-content {
      padding: 10px 12px 12px !important;
      display: flex !important;
      flex-direction: column !important;
      flex: 1 1 auto !important;
    }

    .gpo-popup-option-title {
      font-size: 14px !important;
      font-weight: 700 !important;
      color: #111 !important;
      line-height: 1.3 !important;
    }

    .gpo-popup-option-addon {
      display: inline-block !important;
      align-self: flex-start !important;
      margin-top: 6px !important;
      background: #e4ff7a !important;
      color: #3a4a00 !important;
      font-weight: 700 !important;
      font-size: 12px !important;
      line-height: 1.2 !important;
      padding: 3px 8px !important;
      border-radius: 6px !important;
    }

    .gpo-popup-option-select {
      display: none !important;
    }

    .gpo-popup-option.active {
      border-color: #111 !important;
      box-shadow: 0 10px 26px rgba(0,0,0,0.10) !important;
    }

    .gpo-popup-option.active::before {
      content: "" !important;
      position: absolute !important;
      inset: 0 !important;
      border: 2px solid #111 !important;
      border-radius: inherit !important;
      pointer-events: none !important;
      z-index: 3 !important;
    }

    .gpo-popup-option.active::after {
      content: "✓" !important;
      position: absolute !important;
      top: 10px !important;
      right: 10px !important;
      width: 28px !important;
      height: 28px !important;
      border-radius: 999px !important;
      background: #e4ff7a !important;
      color: #2c3a00 !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      z-index: 4 !important;
    }

    .gpo-popup-option.text-only {
      padding: 16px 18px !important;
      border-radius: 14px !important;
    }

    .gpo-popup-option.text-only .gpo-popup-option-content {
      padding: 0 !important;
    }

    .gpo-popup-save {
      border-radius: 999px !important;
    }

    @media (max-width: 767px) {
      .gpo-popup-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      }
    }
  `;

  function injectStyle() {
    var old1 = document.getElementById("gpo-modern-fixes");
    var old2 = document.getElementById("gpo-2026-style");
    var old3 = document.getElementById("gpo-four-column-fix");

    if (old1) old1.remove();
    if (old2) old2.remove();
    if (old3) old3.remove();

    if (document.getElementById("gpo-final-swatch-layout")) return;

    var style = document.createElement("style");
    style.id = "gpo-final-swatch-layout";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  injectStyle();
  document.addEventListener("DOMContentLoaded", injectStyle);
})();


(function () {
  if (window.gmCompactCompleteProductToolsLoaded) return;
  window.gmCompactCompleteProductToolsLoaded = true;

  const root = document.querySelector('[data-gm-product-tools]');
  const isPackageProduct = root && root.dataset.isPackageProduct === 'true';

  let scanTimer = null;
  let priceTimer = null;
  let isAddingToCart = false;

  function getQuantityUnitData() {
    const dataScript = document.getElementById('gm-quantity-unit-data');

    if (!dataScript) return { unit: '', inputLabel: '' };

    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      return { unit: '', inputLabel: '' };
    }
  }

  const quantityUnitData = getQuantityUnitData();

  function decorateQuantityInputs() {
    if (!quantityUnitData.unit) return;

    document.querySelectorAll('#buy-now-qty').forEach(function (input) {
      if (input.closest('.gm-quantity-field')) return;

      const wrapper = document.createElement('div');
      const unit = document.createElement('span');

      wrapper.className = 'gm-quantity-field';
      unit.className = 'gm-quantity-unit';
      unit.setAttribute('aria-hidden', 'true');
      unit.textContent = quantityUnitData.unit;

      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(input);
      wrapper.appendChild(unit);

      if (quantityUnitData.inputLabel) {
        input.setAttribute('aria-label', quantityUnitData.inputLabel);
      }
    });
  }

  function getPriceData() {
    const dataScript = document.getElementById('gm-price-summary-data');

    if (!dataScript) {
      return {
        productTitle: 'Produkt',
        selectedVariantPriceCents: 0,
        variantPrices: {}
      };
    }

    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      return {
        productTitle: 'Produkt',
        selectedVariantPriceCents: 0,
        variantPrices: {}
      };
    }
  }

  const priceData = getPriceData();

  function formatNumber(value, decimals) {
    return Number(value || 0).toLocaleString('da-DK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals || 2
    });
  }

  function formatMoney(value) {
    return Number(value || 0).toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' kr';
  }

  function parseMoney(text) {
    let clean = String(text || '').replace(/[^\d,.-]/g, '');

    if (clean.includes(',')) {
      clean = clean.replace(/\./g, '').replace(',', '.');
    }

    return parseFloat(clean) || 0;
  }

  function getNumberFromText(text) {
    const match = String(text || '').match(/(\d+(?:[,.]\d+)?)/);
    return match ? parseFloat(match[1].replace(',', '.')) : 0;
  }

  function getNumberFromInput(input) {
    return parseFloat(String(input && input.value ? input.value : '').replace(',', '.')) || 0;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function isVisible(element) {
    if (!element) return false;
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  /* RETTET — MOBIL-FEJL: temaet gengiver ofte denne formular flere
     gange på samme side (desktop / mobil / evt. en "sticky" bjælke),
     alle med samme id. document.getElementById() returnerer altid
     kun den FØRSTE i koden, som på mobil typisk er den skjulte
     desktop-version — det var derfor beregningerne ikke opdaterede
     sig på telefon. Løsningen: find ALLE elementer med det id, og
     vælg den der rent faktisk er synlig lige nu. */
  function getProductForm() {
    const forms = Array.from(document.querySelectorAll('#gm-product-add-form'));
    return forms.find(isVisible) || forms[0] || null;
  }

  function getQuantityInput() {
    const inputs = Array.from(document.querySelectorAll('#buy-now-qty'));
    return inputs.find(isVisible) || inputs[0] || null;
  }

  function getMainQuantity() {
    const input = getQuantityInput();
    if (!input) return 1;

    const qty = parseFloat(String(input.value || '').replace(',', '.')) || 1;
    return qty > 0 ? qty : 1;
  }

  function getAddToCartButton() {
    const form = getProductForm();

    if (!form) return null;

    const buttons = Array.from(
      form.querySelectorAll('#gm-add-to-cart-button, button[name="add"], button[type="submit"]')
    );

    return buttons.find(isVisible) || buttons[0] || null;
  }

  function getCurrentVariantId() {
    const form = getProductForm();
    const input = form ? form.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');

    return input ? String(input.value || '') : '';
  }

  function getCurrentUnitPrice() {
    const variantId = getCurrentVariantId();

    if (variantId && priceData.variantPrices && priceData.variantPrices[variantId] !== undefined) {
      return Number(priceData.variantPrices[variantId] || 0) / 100;
    }

    return Number(priceData.selectedVariantPriceCents || 0) / 100;
  }


  /* =====================================================
     SEKTION 3 (JS) — PAKKE-BEREGNER
     ===================================================== */
  function initPackageAreaCalculator() {
    const quantityInput = getQuantityInput();

    document.querySelectorAll('[data-gm-area-calculator]').forEach(function (calculator) {
      if (!quantityInput) return;
      if (calculator.dataset.gmAreaReady === 'true') return;

      const packageCount = calculator.querySelector('.gm-package-count');
      const areaTotal = calculator.querySelector('.gm-area-total');

      if (!packageCount || !areaTotal) return;

      const stepAmount = parseFloat(String(calculator.dataset.stepAmount || '1').replace(',', '.')) || 1;

      function updateAreaCalculator() {
        let quantity = parseFloat(String(quantityInput.value || '').replace(',', '.')) || 0;

        if (quantity < 0) quantity = 0;

        const totalArea = quantity * stepAmount;

        packageCount.textContent = formatNumber(quantity, 3);
        areaTotal.textContent = formatNumber(totalArea, 3);
      }

      quantityInput.addEventListener('input', updateAreaCalculator);
      quantityInput.addEventListener('change', updateAreaCalculator);
      quantityInput.addEventListener('keyup', updateAreaCalculator);

      calculator.dataset.gmAreaReady = 'true';
      updateAreaCalculator();
    });
  }


  /* =====================================================
     SEKTION 7 — GPO / RULLEBEREGNER — KUN IKKE-PAKKEPRODUKTER
     ===================================================== */
  function getSelectedOption(popupBody) {
    return popupBody.querySelector('.gpo-popup-option.active') || popupBody.querySelector('.gpo-popup-option');
  }

  function hasRollWidthOptions(popupBody) {
    const titles = popupBody.querySelectorAll('.gpo-popup-option-title');

    return Array.from(titles).some(function (title) {
      return /meter|metre|m\b/i.test(title.textContent || '');
    });
  }

  function getSelectedRollWidth(popupBody) {
    const option = getSelectedOption(popupBody);
    const title = option ? option.querySelector('.gpo-popup-option-title') : null;

    if (!title) return 0;

    return getNumberFromText(title.textContent);
  }

  function getSelectedRollPrice(popupBody) {
    const option = getSelectedOption(popupBody);
    const addon = option ? option.querySelector('.gpo-popup-option-addon') : null;

    if (!addon) return 0;

    return parseMoney(addon.textContent);
  }

  function createRollCalculator(popupBody) {
    if (isPackageProduct) return;
    if (popupBody.querySelector('.gm-roll-calculator')) return;

    const extraField = popupBody.querySelector('.gpo-popup-extra-field');
    if (!extraField) return;

    const calculator = document.createElement('div');
    calculator.className = 'gm-roll-calculator gm-compact-card';

    calculator.innerHTML = `
      <div class="gm-compact-top">
        <span class="gm-compact-label">Samlet gulvareal</span>
        <span class="gm-compact-badge">Live beregning</span>
      </div>

      <div class="gm-roll-calculator__result">
        <span class="gm-roll-length">1</span>
        <span>m længde</span>
        <span>x</span>
        <span class="gm-roll-width">0</span>
        <span>m bredde</span>
        <span class="gm-roll-calculator__equals">=</span>
        <strong class="gm-roll-total">0</strong>
        <span>m²</span>
      </div>

      <div class="gm-roll-calculator__price-row">
        <span class="gm-roll-calculator__price-label">Estimeret pris</span>
        <span class="gm-roll-calculator__price-value gm-roll-total-price">0,00 kr</span>
      </div>

      <p class="gm-roll-calculator__text">
        Decimaler er tilladt, fx 10.5 meter.
        <span class="gm-roll-calculator__pill">
          Bredde: <span class="gm-roll-width-small">0</span> m
        </span>
        <span class="gm-roll-calculator__pill">
          Pris/m: <span class="gm-roll-price-per-meter">0,00 kr</span>
        </span>
      </p>
    `;

    extraField.insertAdjacentElement('beforebegin', calculator);
  }

  function prepareRollInput(input) {
    if (!input || input.dataset.gmRollDecimalReady === 'true') return;

    input.setAttribute('step', '0.01');
    input.setAttribute('inputmode', 'decimal');
    input.setAttribute('pattern', '[0-9]+([\\.,][0-9]+)?');
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('blur', function () {
      input.value = String(input.value || '').replace(',', '.');
    });

    input.dataset.gmRollDecimalReady = 'true';
  }

  function updateRollCalculator(popupBody) {
    if (isPackageProduct) return;

    const calculator = popupBody.querySelector('.gm-roll-calculator');
    const qtyInput = popupBody.querySelector('.gpo-popup-quantity-proxy, .gpo-quantity__input');

    if (!calculator || !qtyInput) return;

    const widthMeters = getSelectedRollWidth(popupBody);
    const pricePerMeter = getSelectedRollPrice(popupBody);

    let lengthMeters = getNumberFromInput(qtyInput);

    if (lengthMeters < 0) {
      lengthMeters = 0;
      qtyInput.value = 0;
    }

    const totalM2 = lengthMeters * widthMeters;
    const totalPrice = lengthMeters * pricePerMeter;

    const lengthEl = calculator.querySelector('.gm-roll-length');
    const widthEl = calculator.querySelector('.gm-roll-width');
    const widthSmallEl = calculator.querySelector('.gm-roll-width-small');
    const totalEl = calculator.querySelector('.gm-roll-total');
    const pricePerMeterEl = calculator.querySelector('.gm-roll-price-per-meter');
    const totalPriceEl = calculator.querySelector('.gm-roll-total-price');

    if (lengthEl) lengthEl.textContent = formatNumber(lengthMeters, 2);
    if (widthEl) widthEl.textContent = formatNumber(widthMeters, 2);
    if (widthSmallEl) widthSmallEl.textContent = formatNumber(widthMeters, 2);
    if (totalEl) totalEl.textContent = formatNumber(totalM2, 2);
    if (pricePerMeterEl) pricePerMeterEl.textContent = formatMoney(pricePerMeter);
    if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalPrice);
  }

  function initRollPopup(popupBody) {
    if (isPackageProduct) return;
    if (!popupBody) return;
    if (!hasRollWidthOptions(popupBody)) return;

    const extraField = popupBody.querySelector('.gpo-popup-extra-field');
    const qtyInput = popupBody.querySelector('.gpo-popup-quantity-proxy, .gpo-quantity__input');

    if (!extraField || !qtyInput) return;

    createRollCalculator(popupBody);
    prepareRollInput(qtyInput);

    const qtyTitle = popupBody.querySelector('.gpo-popup-extra-title');

    if (qtyTitle) {
      qtyTitle.textContent = 'Antal meter i længden';
    }

    if (popupBody.dataset.gmRollEventsReady !== 'true') {
      popupBody.addEventListener('input', function () {
        updateRollCalculator(popupBody);
      });

      popupBody.addEventListener('change', function () {
        updateRollCalculator(popupBody);
      });

      popupBody.addEventListener('click', function (event) {
        if (event.target.closest('.gpo-popup-option')) {
          setTimeout(function () {
            updateRollCalculator(popupBody);
          }, 120);
        }
      });

      popupBody.dataset.gmRollEventsReady = 'true';
    }

    updateRollCalculator(popupBody);
  }

  function scanRollPopups() {
    if (isPackageProduct) return;

    document.querySelectorAll('.gpo-popup-body').forEach(function (popupBody) {
      initRollPopup(popupBody);
    });
  }

  function scheduleRollScan() {
    if (isPackageProduct) return;

    clearTimeout(scanTimer);

    scanTimer = setTimeout(function () {
      scanRollPopups();
    }, 120);
  }


  /* =====================================================
     SEKTION 4 (JS) — ADD TO CART
     ===================================================== */
  function getCartSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(',');
    }

    if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      return cartNotification.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(',');
    }

    return 'cart-drawer,cart-icon-bubble';
  }

  function renderCartSections(data) {
    if (!data || !data.sections) return;

    Object.keys(data.sections).forEach(function (sectionId) {
      const html = data.sections[sectionId];

      if (!html) return;

      const currentSection = document.getElementById('shopify-section-' + sectionId);
      const newDocument = new DOMParser().parseFromString(html, 'text/html');
      const newSection = newDocument.getElementById('shopify-section-' + sectionId);

      if (currentSection && newSection) {
        currentSection.innerHTML = newSection.innerHTML;
      }
    });
  }

  function openCartDrawer(data) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
      return;
    }

    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(data);
      return;
    }

    renderCartSections(data);

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: true }
    }));

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: data
    }));

    const cartTrigger = document.querySelector(
      '#cart-icon-bubble, [data-cart-drawer-open], [data-cart-drawer-toggle], [aria-controls*="CartDrawer"], [aria-controls*="cart-drawer"]'
    );

    if (cartTrigger) {
      const oldHref = cartTrigger.getAttribute('href');

      if (oldHref) {
        cartTrigger.setAttribute('href', '#');
      }

      cartTrigger.click();

      if (oldHref) {
        cartTrigger.setAttribute('href', oldHref);
      }

      return;
    }

    if (cartDrawer) {
      cartDrawer.classList.add('active', 'animate', 'open', 'is-open');
      cartDrawer.setAttribute('open', '');
      cartDrawer.removeAttribute('aria-hidden');
      document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    }
  }

  function setButtonState(button, text, disabled) {
    if (!button) return;

    button.innerText = text;
    button.disabled = disabled;
  }

  async function ajaxAddToCart(event) {
    const form = getProductForm();
    const button = getAddToCartButton();
    const qtyInput = getQuantityInput();

    if (!form || !button || !qtyInput) return;

    if (event) {
      event.preventDefault();
    }

    if (isAddingToCart) return;
    isAddingToCart = true;

    const minQuantity = parseInt(qtyInput.dataset.minQuantity, 10) || 1;
    let selectedQuantity = parseInt(qtyInput.value, 10) || minQuantity;

    if (selectedQuantity < minQuantity) {
      qtyInput.value = minQuantity;
      alert('Mindste antal for dette produkt er ' + minQuantity + '.');
      isAddingToCart = false;
      return;
    }

    setButtonState(button, 'Tilføjer...', true);

    const formData = new FormData(form);
    formData.append('sections', getCartSections());
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw data;
      }

      setButtonState(button, 'Tilføjet', true);
      openCartDrawer(data);

      setTimeout(function () {
        setButtonState(button, 'Tilføj til kurv', false);
        isAddingToCart = false;
      }, 1200);

    } catch (error) {
      console.error(error);
      setButtonState(button, 'Tilføj til kurv', false);
      isAddingToCart = false;

      alert('Produktet kunne ikke tilføjes. Prøv igen.');
    }
  }

  function initAddToCart() {
    const form = getProductForm();

    if (!form) return;
    if (form.dataset.gmAddReady === 'true') return;

    form.addEventListener('submit', ajaxAddToCart);
    form.dataset.gmAddReady = 'true';
  }


  /* =====================================================
     SEKTION 8 — PRISOVERSIGT + PLACERING
     ===================================================== */
  function placePriceSummaryUnderButton() {
    const summary = document.querySelector('[data-gm-price-summary]');
    const button = getAddToCartButton();

    if (!summary || !button) return;

    if (button.nextElementSibling !== summary) {
      button.insertAdjacentElement('afterend', summary);
    }
  }

  /* NYT: flytter CTA-knapperne (Prøvekasse/Mængderabat), så de altid
     havner lige under prisoversigten — samme teknik som ovenfor.
     Det er det der sikrer at de aldrig ender et andet sted i DOM'en
     med en anden (smallere) bredde end resten af widgeten. */
  function placeCtaListAfterSummary() {
    const summary = document.querySelector('[data-gm-price-summary]');
    const ctaList = document.querySelector('[data-gm-cta-list]');

    if (!summary || !ctaList) return;

    if (summary.nextElementSibling !== ctaList) {
      summary.insertAdjacentElement('afterend', ctaList);
    }
  }

  function getInputLabel(input) {
    if (!input) return null;

    if (input.labels && input.labels.length) {
      return input.labels[0];
    }

    if (input.id) {
      return document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
    }

    return null;
  }

  function getFieldName(input) {
    if (!input) return 'Tilvalg';

    return (
      input.getAttribute('data-field-name') ||
      input.getAttribute('name') ||
      'Tilvalg'
    ).replace('properties[', '').replace('][]', '').replace(']', '');
  }

  function getSelectedOptionName(input) {
    if (!input) return '';

    const value = input.getAttribute('value') || input.value || '';

    return value.trim();
  }

  function getAddonPrice(input) {
    const item = input.closest('.gpo-ov-item') || input.closest('.gpo-swatches') || input.closest('.gpo-element');
    const label = getInputLabel(input);

    const addonElement =
      (label && label.querySelector('.addOn')) ||
      (item && item.querySelector('.addOn'));

    if (!addonElement) return 0;

    return parseMoney(addonElement.textContent);
  }

  function getOwnOptionQuantity(input) {
    const item = input.closest('.gpo-ov-item') || input.closest('.gpo-swatches') || input.closest('.gpo-element');

    if (!item) return null;

    const quantityInput = item.querySelector('.gpo-ov-quantity input.quantity__input, .gpo-ov-quantity input[type="number"]');

    if (!quantityInput) return null;

    const quantity = parseFloat(String(quantityInput.value || '').replace(',', '.')) || 1;

    return quantity > 0 ? quantity : 1;
  }

  function getSelectedGpoOptions() {
    const mainQuantity = getMainQuantity();
    const options = [];

    document.querySelectorAll('.gpo-app input[type="radio"]:checked, .gpo-app input[type="checkbox"]:checked').forEach(function (input) {
      if (!input || input.disabled) return;

      const addonPrice = getAddonPrice(input);

      if (addonPrice <= 0) return;

      const ownQuantity = getOwnOptionQuantity(input);
      const multiplier = ownQuantity !== null ? ownQuantity : mainQuantity;

      options.push({
        fieldName: getFieldName(input),
        optionName: getSelectedOptionName(input),
        unitPrice: addonPrice,
        quantity: multiplier,
        usesOwnQuantity: ownQuantity !== null,
        total: addonPrice * multiplier
      });
    });

    return options;
  }

  function getProductTotal() {
    return getCurrentUnitPrice() * getMainQuantity();
  }

  function renderOptionRows(options) {
    const container = document.querySelector('[data-gm-option-rows]');

    if (!container) return;

    if (!options.length) {
      container.classList.add('is-empty');

      if (container.innerHTML !== '') {
        container.innerHTML = '';
      }

      return;
    }

    container.classList.remove('is-empty');

    const html = options.map(function (option) {
      const quantityText = option.usesOwnQuantity
        ? formatNumber(option.quantity, 2) + ' valgt antal'
        : formatNumber(option.quantity, 2) + ' x produktantal';

      return `
        <div class="gm-price-summary__row">
          <div>
            <div class="gm-price-summary__name">
              ${escapeHtml(option.fieldName)}: ${escapeHtml(option.optionName)}
            </div>
            <span class="gm-price-summary__detail">
              ${escapeHtml(quantityText)} x ${escapeHtml(formatMoney(option.unitPrice))}
            </span>
          </div>
          <div class="gm-price-summary__price">
            ${escapeHtml(formatMoney(option.total))}
          </div>
        </div>
      `;
    }).join('');

    if (container.innerHTML.trim() !== html.trim()) {
      container.innerHTML = html;
    }
  }

  function updatePriceSummary() {
    placePriceSummaryUnderButton();
    placeCtaListAfterSummary();

    const mainQuantity = getMainQuantity();
    const unitPrice = getCurrentUnitPrice();
    const baseTotal = getProductTotal();
    const options = getSelectedGpoOptions();
    const optionsTotal = options.reduce(function (sum, option) {
      return sum + option.total;
    }, 0);

    const grandTotal = baseTotal + optionsTotal;

    const productNameEl = document.querySelector('[data-gm-product-name]');
    const productDetailEl = document.querySelector('[data-gm-product-detail]');
    const productTotalEl = document.querySelector('[data-gm-product-total]');
    const baseTotalEl = document.querySelector('[data-gm-base-total]');
    const optionsTotalEl = document.querySelector('[data-gm-options-total]');
    const grandTotalEl = document.querySelector('[data-gm-grand-total]');
    const grandTotalTopEl = document.querySelector('[data-gm-grand-total-top]');

    if (productNameEl) productNameEl.textContent = priceData.productTitle || 'Produkt';
    if (productDetailEl) {
      const unitLabel = quantityUnitData.unit ? ' ' + quantityUnitData.unit : '';
      productDetailEl.textContent = formatNumber(mainQuantity, 2) + unitLabel + ' × ' + formatMoney(unitPrice);
    }
    if (productTotalEl) productTotalEl.textContent = formatMoney(baseTotal);
    if (baseTotalEl) baseTotalEl.textContent = formatMoney(baseTotal);
    if (optionsTotalEl) optionsTotalEl.textContent = formatMoney(optionsTotal);
    if (grandTotalEl) grandTotalEl.textContent = formatMoney(grandTotal);
    if (grandTotalTopEl) grandTotalTopEl.textContent = formatMoney(grandTotal);

    renderOptionRows(options);
  }

  function schedulePriceUpdate() {
    clearTimeout(priceTimer);

    priceTimer = setTimeout(function () {
      updatePriceSummary();
    }, 90);
  }


  /* =====================================================
     INIT
     ===================================================== */
  function initAll() {
    decorateQuantityInputs();
    initPackageAreaCalculator();
    initAddToCart();
    updatePriceSummary();

    if (!isPackageProduct) {
      scheduleRollScan();
    }
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll();
  }

  document.addEventListener('input', function (event) {
    if (
      event.target.closest('#buy-now-qty') ||
      event.target.closest('.gpo-app')
    ) {
      initPackageAreaCalculator();
      schedulePriceUpdate();
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.closest('#buy-now-qty') ||
      event.target.closest('.gpo-app') ||
      event.target.matches('input[name="id"]')
    ) {
      initPackageAreaCalculator();
      schedulePriceUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.gpo-app') ||
      event.target.closest('.gpo-popup-body') ||
      event.target.closest('.gpo-popup-trigger') ||
      event.target.closest('.quantity__button')
    ) {
      setTimeout(schedulePriceUpdate, 120);
      setTimeout(schedulePriceUpdate, 350);
      setTimeout(schedulePriceUpdate, 750);
      setTimeout(scheduleRollScan, 120);
    }
  });

  document.addEventListener('gpoRenderCompleted', function () {
    schedulePriceUpdate();
    scheduleRollScan();
  });

  document.addEventListener('gpo:rendered', function () {
    schedulePriceUpdate();
    scheduleRollScan();
  });

  document.addEventListener('gpo:changed', function () {
    schedulePriceUpdate();
    scheduleRollScan();
  });

  const observer = new MutationObserver(function () {
    schedulePriceUpdate();

    if (!isPackageProduct) {
      scheduleRollScan();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'value', 'data-quantity', 'class']
  });

  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
})();
